import { freeSet } from '@coreui/icons'
import { logo } from './logo'
import { logoDark } from './logoDark'


export const iconsSet = Object.assign({}, { logo, logoDark} , freeSet )
